export function updateQueryStringParameter(
  uri: string,
  key: string,
  value: string | number
) {
  const re = new RegExp('([?&])' + key + '=.*?(&|#|$)', 'i');
  if (!value) {
    if (uri.match(re)) {
      return uri
        .replace(re, '$1$2')
        .replace(/[?&]$/, '')
        .replace(/([?&])&+/g, '$1')
        .replace(/[?&]#/, '#');
    } else {
      return uri;
    }
  } else {
    if (uri.match(re)) {
      return uri.replace(re, '$1' + key + '=' + value + '$2');
    } else {
      var hash = '';
      if (uri.indexOf('#') !== -1) {
        hash = uri.replace(/.*#/, '#');
        uri = uri.replace(/#.*/, '');
      }
      var separator = uri.indexOf('?') !== -1 ? '&' : '?';
      return uri + separator + key + '=' + value + hash;
    }
  }
}

export const updateQueryStringParameters = (
  uri: string,
  params: { [key: string]: string | null }
) => {
  let finalUri = uri;
  for (const key in params) {
    const value = params[key] || '';
    if (value) {
      finalUri = updateQueryStringParameter(finalUri, key, value);
    }
  }
  return finalUri;
};
export const updateUrlParameter = (
  key: string,
  value: string | number,
  history: any
) => {
  const { pathname, search } = history.location;
  let currentUrl = `${pathname}${search}`;
  currentUrl = updateQueryStringParameter(currentUrl, key, value);
  // Should update the query parameters without adding a new entry in the history
  history.replace(currentUrl);
};

//This function receives a key value dictionary and generates a Url based on it for a get request.
export const generateParameters = (objectList: {
  [key: string]: string | null | undefined;
}): string => {
  const keys = Object.keys(objectList);
  const parametersArray: string[] = [];
  keys.forEach(
    (k) => objectList[k] && parametersArray.push(`${k}=${objectList[k]}`)
  );
  return `?${parametersArray.join('&')}`;
};
